import React, { lazy, Suspense } from 'react';

import { Head as SEO, Team } from '@landing/components';
import Header from 'components/Header';
import { anchorLinks } from 'define/anchorLinks';
import Intro from 'components/Intro';
import EventProgram from 'components/EventProgram';
import Services from 'components/Services';
import Projects from 'components/Projects';
import Offices from 'components/Offices';
import { offices } from 'define/offices';
import ContactUs from 'components/ContactUs';
import Footer from 'components/Footer';
import CookiesPolicy from 'components/CookiesPolicy/CookiesPolicy';
import { useIsSsr } from 'utils/hooks';

import data from './data.json';

const RequestConsultation = lazy(() =>
  import('components/Modals').then(({ RequestConsultation }) => ({
    default: RequestConsultation,
  })),
);

const SuccessModal = lazy(() =>
  import('components/Modals').then(({ SuccessModal }) => ({
    default: SuccessModal,
  })),
);

const ErrorModal = lazy(() =>
  import('components/Modals').then(({ ErrorModal }) => ({
    default: ErrorModal,
  })),
);

export default function Index() {
  const isSsr = useIsSsr();

  return (
    <>
      <Header anchorLinks={anchorLinks} />
      <Intro {...data.intro} />
      <Team {...data.team} />
      <EventProgram {...data.eventProgram} />
      <Services {...data.services} />
      <Projects {...data.projects} />
      <Offices offices={offices} {...data.offices} />
      <ContactUs {...data.contactUs} organizer={data.aboutOrganizer} />
      <Footer anchorLinks={anchorLinks} />
      <CookiesPolicy />
      {!isSsr && (
        <Suspense fallback={null}>
          <RequestConsultation />
          <SuccessModal />
          <ErrorModal />
        </Suspense>
      )}
    </>
  );
}

export const Head = () => <SEO {...data.head} />;
